/**
 * page component
 * @property nextBeClick {function} this callback of click `next` button, pageNumber will be pass as params.
 * @property pageCount {number} last page number
 * @property nextGroupBeClick {function} callback, next group button be click. pageNumber will be pass as params.
 * @property previousGroupBeClick {function} callback, prev group button be click. pageNumber will be pass as params.
 * @property previousBeClick {function} callback, previous button be click. pageNumber will be pass as params.
 * @property pageBeClick {function} callback, page number be click, pageNumber will be pass as params.
 * @property total {number} total value.
 * @property hasNext {boolean} if has next page
 * @property hasPrevious {boolean} if has previous
 * @property style {obj} page root element style object.
 * @property pagePlus {boolean} if true UI will be display same as px-93's UI.
 * @property selectRows {function} callback , params: 1.pageNumber 2.row value.
 * @property goToPage {function} callback params: pageNumber
 * @property pageSize {number}
 */
import React, { Component } from "react";
import Arrow from "material-ui/svg-icons/av/play-arrow";
import Dialog from "material-ui/Dialog";
import FlatButton from "material-ui/FlatButton";
// css
import "./page.css";

class Page extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ifHasNextGroup: true, // next button display control, default has next group icon
      ifHasPreGroup: false, // previous button display control, default no previous group icon
      pageCount: [1, 2, 3, 4, 5, 6],
      activeIndex: 1, //record pageNumber
      open: false,
      reactiveOpen: false,
      rows: 10,
    };
  }
  componentDidMount() {
    this.refs.goToPage.value = this.state.activeIndex;
  }
  componentWillReceiveProps(nextProps) {
    // if pageCount less than six show pageCount length
    if (nextProps.pageCount <= this.state.pageCount.length) {
      let len = nextProps.pageCount;
      let obj = [];
      for (let i = 0; i < len; i++) {
        obj.push(i + 1);
      }
      this.setState({
        pageCount: obj,
        ifHasNextGroup: false,
      });
    }
    if (nextProps.reactive_success && !nextProps.reactive_on_progress) {
      this.setState({
        reactiveSuccessOpen: true,
        reactiveOpen: false,
      });
    }
    // if (typeof nextProps.pageNumber === 'number' && nextProps.pageNumber !== this.state.activeIndex) {
    //   this.setState({
    //     activeIndex: nextProps.pageNumber
    //   }, () => {
    //     this.refs.goToPage.value = this.state.activeIndex;
    //   })
    // }
  }
  goToNext() {
    // if activeIndex greater than total return
    // if (this.state.activeIndex % 6 === 0) {
    //   this.state.activeIndex++;
    //   this.nextToGroup()
    // } else {
    //   this.props.nextBeClick(this.state.activeIndex++)
    // }
    this.setState(
      {
        activeIndex: ++this.state.activeIndex,
      },
      () => {
        this.props.nextBeClick(this.state.activeIndex);
        this.refs.goToPage.value = this.state.activeIndex;
      },
    );
  }
  nextToGroup() {
    // when more than six add item
    let count = [];
    // add callback for setState function
    count = this.state.pageCount
      .map(item => {
        return item + 6;
      })
      .filter(item => item <= this.props.pageCount);
    this.setState(
      {
        pageCount: count,
        activeIndex: count[0],
      },
      () => {
        if (this.state.pageCount[0] > 6) {
          this.setState({
            ifHasPreGroup: true, //set pre group icon available
          });
        }
        if (
          this.state.pageCount[this.state.pageCount.length - 1] ===
          this.props.pageCount
        ) {
          this.setState({
            ifHasNextGroup: false, //set next group icon invalid
          });
        }
        this.props.nextGroupBeClick(this.state.activeIndex);
      },
    );
  }
  previousToGroup() {
    let count;
    if (this.state.pageCount.length < 6) {
      count = [];
      for (var i = 5; i >= 0; i--) {
        count.push(this.state.pageCount[0] - 1 - i);
      }
    } else {
      count = this.state.pageCount.map(item => {
        return item - 6;
      });
    }
    // add callback for setState function
    this.setState(
      {
        pageCount: count,
        activeIndex: count[0],
      },
      () => {
        this.props.previousGroupBeClick(this.state.activeIndex);
        // when click previous group icon and no previous page hidden icon
        if (this.state.activeIndex === 1) {
          this.setState({
            ifHasPreGroup: false,
          });
        }
        if (
          this.state.pageCount[this.state.pageCount.length - 1] <
          this.props.pageCount
        ) {
          this.setState({
            ifHasNextGroup: true, //set next group icon invalid
          });
        }
      },
    );
  }

  goToPrevious() {
    // if (this.state.activeIndex % 6 === 1) {
    //   this.previousToGroup()
    // } else {
    //   this.props.previousBeClick(--this.state.activeIndex);
    // }
    this.setState(
      {
        activeIndex: --this.state.activeIndex,
      },
      () => {
        this.props.previousBeClick(this.state.activeIndex);
        this.refs.goToPage.value = this.state.activeIndex;
      },
    );
  }
  handleClickPage(page) {
    this.props.pageBeClick(page);
    this.setState({
      activeIndex: page,
    });
  }
  handleSelectRows(e, index, value) {
    this.setState({
      rows: value,
    });
    this.props.selectRows(this.state.activeIndex, value);
  }
  handlePageInput(e) {
    if (!/[0-9]$/g.test(e.target.value)) {
      this.refs.goToPage.value = "";
    }
  }
  handlePageNumberConfirm(e) {
    if (e.keyCode === 13) {
      if (e.target.value <= this.props.pageCount && e.target.value > 0) {
        this.props.goToPage(e.target.value);
        this.setState({
          activeIndex: +e.target.value,
        });
      } else {
        this.refs.goToPage.value = "";
      }
    }
  }
  render() {
    return (
      <div className="page clearfix" style={this.props.style}>
        <Dialog
          modal={false}
          open={this.state.reactiveSuccessOpen}
          contentStyle={{ width: "480px" }}
        >
          <p
            style={{
              color: "black",
              textAlign: "center",
              fontSize: "16px",
              fontWeight: "bold",
            }}
          >
            Depending on the audience size, <br />
            reactivation may take several hours before
            <br />
            changing status from Pending to Active
          </p>
          <div
            className="btns"
            style={{ textAlign: "center", marginTop: "1em" }}
          >
            <FlatButton
              label="Close"
              backgroundColor="#00A3AD"
              labelStyle={{
                color: "#FFF",
                padding: 0,
                verticalAlign: "inherit",
                textTransform: "capitalize",
              }}
              onClick={() => {
                this.setState(
                  {
                    reactiveSuccessOpen: false,
                  },
                  () => {
                    this.props.history.push("/segments/list/active");
                  },
                );
              }}
              hoverColor="#00A3AD"
            />
          </div>
        </Dialog>
        <Dialog
          modal={false}
          open={this.state.open}
          onRequestClose={this.handleClose}
          contentStyle={{ width: "39%" }}
        >
          <p
            style={{
              color: "black",
              textAlign: "center",
              fontSize: "16px",
              fontWeight: "bold",
            }}
          >
            Click confirm to archive this audience
          </p>
          <div
            className="btns"
            style={{ textAlign: "center", marginTop: "1em" }}
          >
            <FlatButton
              label="Cancel"
              backgroundColor="#FFF"
              labelStyle={{ color: "black", textTransform: "capitalize" }}
              onClick={() => {
                this.setState({ open: false });
              }}
              hoverColor="#FFF"
              className="btn-aa-info mr-20"
            />
            <FlatButton
              label="Archive Segment"
              backgroundColor="#00A3AD"
              labelStyle={{
                color: "#FFF",
                padding: "10px",
                verticalAlign: "inherit",
                textTransform: "capitalize",
              }}
              onClick={() => {
                this.props.archiveFun();
                setTimeout(
                  function() {
                    this.setState({ open: false });
                  }.bind(this),
                  1000,
                );
              }}
              hoverColor="#00A3AD"
            />
          </div>
        </Dialog>
        <Dialog
          modal={false}
          open={this.state.reactiveOpen}
          onRequestClose={this.handleClose}
          contentStyle={{ width: "39%" }}
        >
          <p
            style={{
              color: "black",
              textAlign: "center",
              fontSize: "16px",
              fontWeight: "bold",
            }}
          >
            Click confirm to unarchive this audience
          </p>
          <div
            className="btns"
            style={{ textAlign: "center", marginTop: "1em" }}
          >
            <FlatButton
              label="Cancel"
              backgroundColor="#FFF"
              labelStyle={{ color: "black", textTransform: "capitalize" }}
              onClick={() => {
                this.setState({ reactiveOpen: false });
              }}
              hoverColor="#FFF"
              className="btn-aa-info mr-20"
            />
            <FlatButton
              label="Confirm"
              backgroundColor="#00A3AD"
              disabled={this.props.reactive_on_progress}
              labelStyle={{
                color: "#FFF",
                padding: 0,
                verticalAlign: "inherit",
                textTransform: "capitalize",
              }}
              onClick={() => {
                this.props.unArchiveFun(
                  this.props.segmentIds.values().next().value,
                );
              }}
              hoverColor="#00A3AD"
            />
          </div>
        </Dialog>
        {/*<button onClick={() => this.nextToGroup()} style={{ display: this.state.ifHasNextGroup ? 'block' : 'none' }}>&gt;</button>*/}
        {this.props.pagePlus ? (
          // for new page ui
          <div className="page-plus clearfix">
            {this.props.segmentIds && this.props.archiveFun && (
              <a
                className="btn btn-default btn-aa-default ml-20"
                style={{ float: "left" }}
                disabled={this.props.segmentIds.size <= 0}
                onClick={() => {
                  this.setState({ open: true });
                }}
              >
                Archive
              </a>
            )}
            {this.props.segmentIds && this.props.editFun && (
              <a
                className="btn btn-default btn-aa-default ml-20"
                style={{ float: "left" }}
                disabled={this.props.segmentIds.size <= 0}
                onClick={() => {
                  this.props.editFun(
                    this.props.segmentIds.values().next().value,
                  );
                }}
              >
                Edit
              </a>
            )}
            {this.props.segmentIds && this.props.unArchiveFun && (
              <a
                className="btn btn-default btn-aa-default ml-20"
                style={{ float: "left" }}
                disabled={this.props.segmentIds.size <= 0}
                onClick={() => {
                  this.setState({ reactiveOpen: true });
                }}
              >
                Reactivate
              </a>
            )}
            <button
              onClick={() => this.goToNext()}
              style={{
                display:
                  this.state.activeIndex < this.props.pageCount
                    ? "block"
                    : "none",
              }}
            >
              {this.props.pagePlus ? (
                <Arrow
                  style={{
                    width: "14px",
                    height: "14px",
                    border: "1px solid #B1B0B0",
                    background: "#E3E3E3",
                  }}
                />
              ) : (
                "Next"
              )}
            </button>
            {/*{*/}
            {/*this.props.total > this.props.pageSize ?*/}
            {/*<div className="page-count">*/}
            {/*{this.props.pageSize * this.state.activeIndex - (this.props.pageSize - 1)} - {this.state.activeIndex * this.props.pageSize > this.props.total ? this.props.total : this.state.activeIndex * this.props.pageSize} of {this.state.activeIndex}*/}
            {/*</div> :*/}
            {/*<div className="page-count">*/}
            {/*1-{this.props.total} of {this.state.activeIndex}*/}
            {/*</div>*/}
            {/*}*/}
            {
              <div className="page-count">
                of {this.props.pageCount > 0 ? this.props.pageCount : "1"}
              </div>
            }
            {this.props.pagePlus && (
              <div className="page-go-to clearfix">
                <small>Pages</small>
                <input
                  type="text"
                  onChange={e => this.handlePageInput(e)}
                  ref="goToPage"
                  onKeyUp={e => this.handlePageNumberConfirm(e)}
                />
              </div>
            )}
            <button
              onClick={() => this.goToPrevious()}
              style={{ display: this.state.activeIndex > 1 ? "block" : "none" }}
            >
              {this.props.pagePlus ? (
                <Arrow
                  style={{
                    width: "14px",
                    height: "14px",
                    border: "1px solid #B1B0B0",
                    background: "#E3E3E3",
                    transform: "rotate(180deg)",
                  }}
                />
              ) : (
                "Pre"
              )}
            </button>
            {/*<button style={{ display: this.state.ifHasPreGroup ? 'block' : 'none' }} onClick={() => this.previousToGroup()}>&lt;</button>*/}
          </div>
        ) : (
          <div className="page-normal">
            <button
              onClick={() => this.goToNext()}
              style={{ display: this.props.hasNext ? "block" : "none" }}
            >
              {this.props.pagePlus ? (
                <Arrow
                  style={{
                    width: "14px",
                    height: "14px",
                    border: "1px solid #B1B0B0",
                    background: "#E3E3E3",
                  }}
                />
              ) : (
                "Next"
              )}
            </button>
            <ul className="page-link clearfix">
              {this.state.pageCount.map((item, index) => (
                <li
                  key={index}
                  className={this.state.activeIndex === item ? "active" : ""}
                  onClick={() => this.handleClickPage(item)}
                >
                  {item}
                </li>
              ))}
            </ul>
            <button
              onClick={() => this.goToPrevious()}
              style={{ display: this.props.hasPrevious ? "block" : "none" }}
            >
              {this.props.pagePlus ? (
                <Arrow
                  style={{
                    width: "14px",
                    height: "14px",
                    border: "1px solid #B1B0B0",
                    background: "#E3E3E3",
                    transform: "rotate(180deg)",
                  }}
                />
              ) : (
                "Pre"
              )}
            </button>
            {/*<button style={{ display: this.state.ifHasPreGroup ? 'block' : 'none' }} onClick={() => this.previousToGroup()}>&lt;</button>*/}
            {this.props.total > 10 ? (
              <div className="page-count">
                {this.props.pageSize * this.state.activeIndex -
                  (this.props.pageSize - 1)}{" "}
                -{" "}
                {this.state.activeIndex * this.props.pageSize > this.props.total
                  ? this.props.total
                  : this.state.activeIndex * this.props.pageSize}{" "}
                of {this.props.total}
              </div>
            ) : this.props.total > 0 ? (
              <div className="page-count">
                1-{this.props.total} of {this.props.total}
              </div>
            ) : (
              <div className="page-count">&nbps;</div>
            )}
          </div>
        )}
        {/*{this.props.pagePlus && (*/}
        {/*<DropDownMenu*/}
        {/*style={{float: 'right', border: '1px solid black', height: '30px', marginTop: '4px'}}*/}
        {/*labelStyle={{height: '30px', lineHeight: '29px', paddingLeft: '8px', paddingRight: '23px'}}*/}
        {/*value={this.state.rows}*/}
        {/*selectedMenuItemStyle={{color: buttonBlueColor()}}*/}
        {/*iconButton={*/}
        {/*<ArrowDown*/}
        {/*/>*/}
        {/*}*/}
        {/*iconStyle={{fill: 'black', padding: 0, width: '24px', height: '24px', right: 0}}*/}
        {/*onChange={(e, index, value) => this.handleSelectRows(e, index, value)}*/}
        {/*>*/}
        {/*{*/}
        {/*[10, 20, 50, 100].map((item, index) => (*/}
        {/*<MenuItem*/}
        {/*key={index}*/}
        {/*value={item}*/}
        {/*label={item}*/}
        {/*disabled={this.props.total < item}*/}
        {/*primaryText={item}*/}
        {/*/>*/}
        {/*) )*/}
        {/*}*/}
        {/*</DropDownMenu>*/}
        {/*)}*/}

        {/*{*/}
        {/*this.props.pagePlus && (*/}
        {/*<span style={{float:'right', marginRight: '8px', fontSize: '14px'}}>Show rows:</span>*/}
        {/*)*/}
        {/*}*/}
      </div>
    );
  }
}

export default Page;



// WEBPACK FOOTER //
// ./src/components/framework/Page/Page.jsx